import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Icon, Intent, InputGroup } from '@blueprintjs/core';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { IconNames } from '@blueprintjs/icons';
import { createForm } from 'rc-form';
// import * as _ from 'lodash';

import slug from 'constants/slug';
import IconRequired from 'components/elements/required-icon';
import QuanHuyenSelect from 'components/elements/select-quan-huyen';
import SelectRoleUser from 'components/elements/select-role-user';
import { SELECT_ITEM_DEFAULT, STYLE } from 'config';
import FacilitySelect from 'components/elements/select-facility';
import NganhNgheSelect from 'components/elements/select-nganh-nghe';
import passwordValidator from 'custom-lib/password-validator';
import PhoneNumber from 'components/elements/phone-number';
import Clearfix from 'components/elements/clearfix';
import { COLOR } from 'config';

var schema = new passwordValidator();

schema
  .is()
  .min(8) // Minimum length 8
  .is()
  .max(100) // Maximum length 100
  .has()
  .uppercase() // Must have uppercase letters
  .has()
  .lowercase() // Must have lowercase letters
  .has()
  .digits() // Must have digits
  .has()
  .symbols(); // Should not have spaces

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;

class UserForm extends React.Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    initialValue: PropTypes.object,
    slugBack: PropTypes.string,
    handelSubmit: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  setInitialValue(keyPath, defaultValue) {
    if (this.props.isEdit) {
      let value = _.result(this.props.initialValue, keyPath, defaultValue);
      if (!value) value = defaultValue;
      return value;
    }
    return defaultValue;
  }

  setSelInitialValue(keyPath, defaultValue, nameLabel) {
    if (this.props.isEdit) {
      let selItem = _.result(this.props.initialValue, keyPath);
      if (!selItem) return defaultValue;
      // if(keyPath === 'role'){
      //   console.log(selItem,"-------")
      // }
      return {
        value: selItem._id,
        label: nameLabel ? selItem[nameLabel] : selItem.Name,
      };
    }
    return defaultValue;
  }

  submit = () => {
    this.props.form.validateFields((error, value) => {
      value.district = _.get(value.district, 'value');
      // value.securityLevel = _.get(value.securityLevel, 'value');

      // console.log(value.role,"value.role")
      value.role = _.get(value.Role, 'value', null);
      value.facility = _.get(value.facility, 'value', null);
      value.sector = _.get(value.sector, 'value', null);
      value.district = _.get(value, 'district', null);
      if (error) return;
      // console.log('validateFields', value);
      if (this.props.handelSubmit) this.props.handelSubmit(value);
    });
  };

  handelOnChangeNganhNghe = (newValue) => {
    this.setState(
      {
        isloadingCoSo: true,
      },
      () => {
        this.setState({
          paramsCoSo: {
            sector: newValue ? newValue.value : '',
          },
          isloadingCoSo: false,
        });
      }
    );
  };

  render() {
    const { getFieldProps, getFieldError, getFieldValue, getFieldDecorator } =
      this.props.form;

    return (
      <div>
        <Row>
          <Col xs={4}>
            <HeaderContainer>
              <Icon
                icon={IconNames.SAVED}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.PRIMARY}
                onClick={this.submit}
                style={{ color: COLOR.SUCCESS }}
              />
              <Clearfix width={8} />
              <Link to={this.props.slugBack ? this.props.slugBack : slug.BASE}>
                <Icon
                  icon={IconNames.DISABLE}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.DANGER}
                />
              </Link>
            </HeaderContainer>
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Tên người dùng
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              disabled={this.props.isEdit}
              placeholder='Tên người dùng'
              {...getFieldProps('UserName', {
                initialValue: this.setInitialValue('UserName', ''),
                rules: [
                  {
                    required: true,
                    message: 'Vui lòng nhập Tên người dùng',
                  },
                  {
                    min: 6,
                    message: 'Tên người dùng độ dài ít nhất 6 ký tự',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('UserName') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Tên
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Tên'
              {...getFieldProps('FirstName', {
                initialValue: this.setInitialValue('FirstName', ''),
                rules: [
                  {
                    required: true,
                    message: 'Vui lòng nhập Tên',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('FirstName') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Họ
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Họ'
              {...getFieldProps('LastName', {
                initialValue: this.setInitialValue('LastName', ''),
                rules: [
                  {
                    required: true,
                    message: 'Vui lòng nhập Họ',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('LastName') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        {!this.props.isEdit && [
          <Row key='passwordRow'>
            <Col xs={4}>
              <LabelContainer style={STYLE.REQUIREDFIELD}>
                Mật khẩu
                <IconRequired />
              </LabelContainer>
            </Col>
            <Col xs={4}>
              <InputGroup
                type='Password'
                placeholder='******'
                {...getFieldProps('Password', {
                  initialValue: this.setInitialValue('Password', ''),
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng nhập Mật khẩu',
                    },
                    // {
                    //   min: 6,
                    //   message: 'Mật khẩu độ dài ít nhất 6 ký tự'
                    // }
                    {
                      validator: (rule, val, callback) => {
                        const isStrongPassword = schema.validate(val);
                        if (!isStrongPassword)
                          callback(
                            new Error(
                              'Mật khẩu phải ít nhất 8 ký tự, bao gồm ký tự Hoa, thường, số, ký tự đặc biệt'
                            )
                          );
                        callback();
                      },
                    },
                  ],
                })}
              />
              <ErrorContainer>
                {(getFieldError('Password') || []).join(', ')}
              </ErrorContainer>
            </Col>
          </Row>,
          <Clearfix key='clearfix_1' height={8} />,
          <Row key='passwordRepeatRow'>
            <Col xs={4}>
              <LabelContainer style={STYLE.REQUIREDFIELD}>
                Xác nhận mật khẩu
                <IconRequired />
              </LabelContainer>
            </Col>
            <Col xs={4}>
              <InputGroup
                type='Password'
                placeholder='******'
                {...getFieldProps('PasswordRepeat', {
                  initialValue: this.setInitialValue('PasswordRepeat', ''),
                  rules: [
                    {
                      validator: (rule, val, callback) => {
                        let pass = getFieldValue('Password');
                        if (val !== pass)
                          callback(new Error('Xác nhận mật khẩu không đúng'));
                        callback();
                      },
                    },
                  ],
                })}
              />
              <ErrorContainer>
                {(getFieldError('PasswordRepeat') || []).join(', ')}
              </ErrorContainer>
            </Col>
          </Row>,
          <Clearfix key='clearfix_2' height={8} />,
        ]}
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Email
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Email'
              {...getFieldProps('Email', {
                initialValue: this.setInitialValue('Email', ''),
                rules: [
                  {
                    required: true,
                    message: 'Vui lòng nhập email',
                  },
                  {
                    type: 'email',
                    message: 'Định dạng email không đúng',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('Email') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Mức độ bảo mật
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            {getFieldDecorator('Role', {
              initialValue: this.setSelInitialValue(
                'role', // name role khong check dc validate
                undefined,
                'Name'
              ),
              rules: [
                {
                  required: true,
                  message: 'Vui lòng nhập mức độ bảo mật',
                },
              ],
            })(<SelectRoleUser hideLabel />)}
            {/* {getFieldDecorator('role', {
              // initialValue: this.setSelInitialValue(
              //   'role',
              //   SELECT_ITEM_DEFAULT
              // ),
              rules: [
                {
                  required: true,
                  message: ' Mức độ bảo mật is required'
                }
              ]
            })(<RoleSelect hideLabel />)} */}
            <ErrorContainer>
              {(getFieldError('Role') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Ngành nghề</LabelContainer>
          </Col>
          <Col xs={4}>
            <NganhNgheSelect
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'sector',
                option: {
                  initialValue: this.setSelInitialValue(
                    'sector',
                    SELECT_ITEM_DEFAULT,
                    'Name'
                  ),
                  trigger: 'onChange',
                  onChange: this.handelOnChangeNganhNghe,
                },
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Cơ sở</LabelContainer>
          </Col>
          <Col xs={4}>
            <FacilitySelect
              hideLabel
              params={this.state.paramsCoSo}
              fieldForm={{
                form: this.props.form,
                name: 'facility',
                option: {
                  initialValue: this.setSelInitialValue(
                    'facility',
                    SELECT_ITEM_DEFAULT,
                    'FacilityNameFull'
                  ),
                },
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Quận/Huyện</LabelContainer>
          </Col>
          <Col xs={4}>
            <QuanHuyenSelect
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'district',
                option: {
                  initialValue: this.setSelInitialValue(
                    'district',
                    SELECT_ITEM_DEFAULT
                  ),
                },
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Fax</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Fax'
              {...getFieldProps('Fax', {
                initialValue: this.setInitialValue('Fax', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Điện thoại</LabelContainer>
          </Col>
          <Col xs={4}>
            <PhoneNumber
              fill
              placeholder='Điện thoại'
              {...getFieldProps('Telephone', {
                initialValue: this.setInitialValue('Telephone', ''),
                rules: [
                  {
                    pattern: '^(0|84|02|\\+84)?[1-9][0-9]{8}$',
                    message: 'Điện thoại sai định dạng',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('Telephone') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Tổ chức</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Tổ chức'
              {...getFieldProps('Organization', {
                initialValue: this.setInitialValue('Organization', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Đơn vị tổ chức</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Đơn vị tổ chức'
              {...getFieldProps('OrganizationUnit', {
                initialValue: this.setInitialValue('OrganizationUnit', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
      </div>
    );
  }
}

export default createForm()(UserForm);



// WEBPACK FOOTER //
// ./src/containers/UserContainer/UserForm/index.js